"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialSettings = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdFormik = require("cccisd-formik");
var _settingsWrapper = _interopRequireDefault(require("../../../helpers/settingsWrapper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var initialSettings = {
  color: 'primaryColor',
  isColorLightened: true
};
exports.initialSettings = initialSettings;
var _default = (0, _settingsWrapper["default"])({
  initialValues: initialSettings
})(function (_ref) {
  var questSettings = _ref.questSettings;
  return questSettings.frameStyleSettings && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].settings
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "color",
    component: _cccisdFormik.CccisdColorPicker
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "isColorLightened",
    component: _cccisdFormik.CccisdCheckboxInput,
    label: "Lighten Color"
  }));
});
exports["default"] = _default;